import React from 'react';
import {
  Section,
  LinksWrapper,
  PageLink,
  Title,
  Overview,
  Arrow,
} from './style';

const PageNavigation = (props) => {
  const { prev, prevLink, next, nextLink } = props;
  return (
    <Section>
      <LinksWrapper>
        <PageLink to={prevLink} navType={'prev'}>
          <Title>{prev && prev.title}</Title>
          <Overview>{prev && prev.overview}</Overview>
          <Arrow />
        </PageLink>
        <PageLink to={nextLink} navType={'next'}>
          <Title>{next && next.title}</Title>
          <Overview>{next && next.overview}</Overview>
          <Arrow transform={'rotate(180)'} />
        </PageLink>
      </LinksWrapper>
    </Section>
  );
};

export default PageNavigation;
